export default __webpack_public_path__ + "static/okc_seint_logo-86c81ec7cd88b85ea0a4b133c45103a0.png";